// extracted by mini-css-extract-plugin
module.exports = {"varAdditional04Extra100":"var(--tkww-union-color-additional-04extra-100, #FFF5ED)","container":"container--e4cc8","noteText":"noteText--9605a primary--8529c"};